import { epicRequest } from 'app'

export const POST_LIST_FETCH = 'POST_LIST_FETCH'
export const POST_LIST_FETCH_ERROR = 'POST_LIST_FETCH_ERROR'
export const POST_LIST_FETCH_FULFILLED = 'POST_LIST_FETCH_FULFILLED'
export const POST_LIST_FETCH_CANCELED = 'POST_LIST_FETCH_CANCELED'

export const POST_LIST_ADD = 'POST_LIST_ADD'
export const POST_LIST_ADD_ERROR = 'POST_LIST_ADD_ERROR'
export const POST_LIST_ADD_FULFILLED = 'POST_LIST_ADD_FULFILLED'
export const POST_LIST_ADD_CANCELED = 'POST_LIST_ADD_CANCELED'

export const POST_LIST_DELETE = 'POST_LIST_DELETE'
export const POST_LIST_DELETE_ERROR = 'POST_LIST_DELETE_ERROR'
export const POST_LIST_DELETE_FULFILLED = 'POST_LIST_DELETE_FULFILLED'
export const POST_LIST_DELETE_CANCELED = 'POST_LIST_DELETE_CANCELED'

export const POST_REACTION_ADD = 'POST_REACTION_ADD'
export const POST_REACTION_ADD_ERROR = 'POST_REACTION_ADD_ERROR'
export const POST_REACTION_ADD_FULFILLED = 'POST_REACTION_ADD_FULFILLED'
export const POST_REACTION_ADD_CANCELED = 'POST_REACTION_ADD_CANCELED'

export const POST_REACTION_DELETE = 'POST_REACTION_DELETE'
export const POST_REACTION_DELETE_ERROR = 'POST_REACTION_DELETE_ERROR'
export const POST_REACTION_DELETE_FULFILLED = 'POST_REACTION_DELETE_FULFILLED'
export const POST_REACTION_DELETE_CANCELED = 'POST_REACTION_DELETE_CANCELED'

export const POST_LIST_INITIAL_STATE = {
  data: [],
  error: null,
  loaded: false,
  page: null,
  pagination: null,
  typeId: null,
}

export const postListFetch = (type, typeId, page, wall) => ({
  payload: {
    page,
    type,
    typeId,
    wall,
  },
  type: POST_LIST_FETCH,
})

export const postListFetchFulfilled = (payload) => ({
  payload,
  type: POST_LIST_FETCH_FULFILLED,
})

export const postListFetchCanceled = () => ({
  payload: null,
  type: POST_LIST_FETCH_CANCELED,
})

export const postListFetchError = (payload) => ({
  payload,
  type: POST_LIST_FETCH_ERROR,
})

export const postListFetchEpic = epicRequest({
  actionType: POST_LIST_FETCH,
  errorAction: postListFetchError,
  fulfilledAction: (response, action) => {
    response.typeId = action.payload.typeId
    return postListFetchFulfilled(response)
  },
  request: ({ payload }) => {
    const page = payload.page > 1 ? `?page=${payload.page}&` : '?'
    return `${payload.type.replaceAll(/(_+)/g, '/')}/${payload.typeId}/${
      payload.wall ? 'wall' : 'posts'
    }${page}per_page=10`
  },
  untilTypes: POST_LIST_FETCH_CANCELED,
})

export const postListAdd = ({ images, message, type, typeId, url, version, wall }) => ({
  notification: {
    id: [type, typeId, wall],
    title: 'Creando publicación...',
  },
  payload: {
    images,
    message,
    type,
    typeId,
    url,
    version,
    wall,
  },
  type: POST_LIST_ADD,
})

export const postListAddFulfilled = (payload) => ({
  payload,
  type: POST_LIST_ADD_FULFILLED,
})

export const postListAddCanceled = () => ({
  payload: null,
  type: POST_LIST_ADD_CANCELED,
})

export const postListAddError = (payload) => ({
  payload,
  type: POST_LIST_ADD_ERROR,
})

export const postListAddEpic = epicRequest({
  actionType: POST_LIST_ADD,
  errorAction: postListAddError,
  fulfilledAction: postListAddFulfilled,
  request: ({ payload }) => {
    const { images, message, type, typeId, url, version } = payload
    const formData = new FormData()
    const fileNames = Object.keys(images)
    const formPicturesKey = fileNames.length > 1 ? 'picture[]' : 'picture'

    fileNames.forEach((imageName) => formData.append(formPicturesKey, images[imageName]))
    formData.append('message', message ? message.trim() : '')
    formData.append('url', url)
    formData.append('version', version)

    return {
      body: formData,
      method: 'post',
      url: `${type.replaceAll(/(_+)/g, '/')}/${typeId}/post`,
    }
  },
  untilTypes: POST_LIST_ADD_CANCELED,
})

export const postListDelete = (type, id, wall) => ({
  payload: {
    id,
    type,
    wall,
  },
  type: POST_LIST_DELETE,
})

export const postListDeleteFulfilled = (payload) => ({
  payload,
  type: POST_LIST_DELETE_FULFILLED,
})

export const postListDeleteError = (payload) => ({
  payload,
  type: POST_LIST_DELETE_ERROR,
})

export const postListDeleteCanceled = () => ({
  payload: null,
  type: POST_LIST_DELETE_CANCELED,
})

export const postListDeleteEpic = epicRequest({
  actionType: POST_LIST_DELETE,
  errorAction: postListDeleteError,
  fulfilledAction: postListDeleteFulfilled,
  request: ({ payload }) => ({
    method: 'delete',
    url: `${payload.type.replaceAll(/(_+)/g, '/')}/${payload.wall ? 'wall' : 'post'}/${payload.id}`,
  }),
  untilTypes: POST_LIST_DELETE_CANCELED,
})

export const postReactionAdd = (type, typeId, reaction) => ({
  payload: {
    reaction,
    type,
    typeId,
  },
  type: POST_REACTION_ADD,
})

export const postReactionAddFulfilled = (payload) => ({
  payload,
  type: POST_REACTION_ADD_FULFILLED,
})

export const postReactionAddError = (payload) => ({
  payload,
  type: POST_REACTION_ADD_ERROR,
})

export const postReactionAddCanceled = () => ({
  payload: null,
  type: POST_REACTION_ADD_CANCELED,
})

export const postReactionAddEpic = epicRequest({
  actionType: POST_REACTION_ADD,
  errorAction: postReactionAddError,
  fulfilledAction: postReactionAddFulfilled,
  overlap: true,
  request: ({ payload }) => ({
    body: { reaction: encodeURIComponent(payload.reaction) },
    method: 'post',
    url: `${payload.type.replaceAll(/(_+)/g, '/')}/post/${payload.typeId}/reaction`,
  }),
  untilTypes: POST_REACTION_ADD_CANCELED,
})

export const postReactionDelete = (type, typeId, reaction) => ({
  payload: {
    reaction,
    type,
    typeId,
  },
  type: POST_REACTION_DELETE,
})

export const postReactionDeleteFulfilled = (payload) => ({
  payload,
  type: POST_REACTION_DELETE_FULFILLED,
})

export const postReactionDeleteError = (payload) => ({
  payload,
  type: POST_REACTION_DELETE_ERROR,
})

export const postReactionDeleteCanceled = () => ({
  payload: null,
  type: POST_REACTION_DELETE_CANCELED,
})

export const postReactionDeleteEpic = epicRequest({
  actionType: POST_REACTION_DELETE,
  errorAction: postReactionDeleteError,
  fulfilledAction: postReactionDeleteFulfilled,
  overlap: true,
  request: ({ payload }) => ({
    method: 'delete',
    url: `${payload.type.replaceAll(/(_+)/g, '/')}/post/${payload.typeId}/reaction/${encodeURIComponent(
      payload.reaction,
    )}`,
  }),
  untilTypes: POST_REACTION_DELETE_CANCELED,
})
